(() => {
	angular.module('main').directive('btnAddNewJobElement', btnAddNewJobElement);

	function btnAddNewJobElement() {
		return {
			restrict: 'E',
			scope: {
				add: '&',
				icon: '@',
				imgSrc: '@',
				title: '@',
				description: '@',
				disableComponent: '='
			},
			template: `<div class="add-new-item" ng-click="onButtonClicked($event)" ng-class="{'add-new-item-disabled': disableComponent }">
                        <i class="{{icon}} mr-18" ng-if="icon"></i>
                        <img ng-src="{{imgSrc}}" class="add-new-pic" ng-if="imgSrc">
                        <div>
                            <h2 class="an-item-title">{{title}}</h2>
                            <div class="an-item-description">{{description}}</div>
                        </div>
                    </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.isDisabled = false;

				scope.onButtonClicked = event => {
					if (!scope.isDisabled) {
						scope.add({ event });
					}
				};

				scope.$on('spBrandsRequest', (event, data) => {
					scope.isDisabled = data;
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnAddNewJobElement.js